// ACT ranges are checked before the broader NSW range.
export function deriveStateCodeFromPostcode(postcode) {
  const pc = Number.parseInt(postcode, 10);
  if (Number.isNaN(pc)) return null;
  if ((pc >= 2600 && pc <= 2618) || (pc >= 2900 && pc <= 2920)) return "ACT";
  if ((pc >= 1000 && pc <= 1999) || (pc >= 2000 && pc <= 2999)) return "NSW";
  if (pc >= 3000 && pc <= 3999) return "VIC";
  if (pc >= 4000 && pc <= 4999) return "QLD";
  if (pc >= 5000 && pc <= 5999) return "SA";
  if (pc >= 6000 && pc <= 6999) return "WA";
  if (pc >= 7000 && pc <= 7999) return "TAS";
  if (pc >= 800 && pc <= 999) return "NT";
  return null;
}
